import ActionBar from './ActionBar';
import ActionBarConnector from './ActionBarConnector';

const ConnectedComponent = () => <ActionBarConnector component={ActionBar} />;

export default ConnectedComponent;
